import { render, staticRenderFns } from "./NolaNovelContestConfirmDialog.vue?vue&type=template&id=364ffbf7&scoped=true"
import script from "./NolaNovelContestConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./NolaNovelContestConfirmDialog.vue?vue&type=script&lang=ts"
import style0 from "./NolaNovelContestConfirmDialog.vue?vue&type=style&index=0&id=364ffbf7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364ffbf7",
  null
  
)

export default component.exports